<script>
import Testimonial from "../Testimonial.vue";

export default {
  components: { Testimonial },
  name: "DeluxeLeft",
  data: function() {
    return {
      testimonials: {
        kristin: {
          photo: "powerdrops/testimonial-kristin.png",
          name: "Kristín Sjofn",
          quote: `Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.`
        },
        tammy: {
          photo: "powerdrops/testimonial-tammy.png",
          name: "Tammy Kell",
          quote: `I just watched Lesson One. LOVED IT!!! Wrote a full page of notes. I absolutely LOVE learning and feel SO fortunate I found Dropsmart. I can't wait for the next lesson. VERY informative.
                    Melani, you have inspired and motivated me to continue my aromatherapy journey. I appreciate you very much. Your team as well. Leandro has been phenomenal assisting me when I've had technical problems!!
                    Please continue to include chemistry education as I feel it is truly important for the overall understanding of using and blending.`
        },
        sylvia: {
          photo: "powerdrops/testimonial-sylvia.png",
          name: "Sylvia Provenski",
          quote: `I absolutely LOVE Dropsmart! And I love our Power Drops course! I go on every day and check out different conditions and then look at which are the best oils for that condition. I'm always surprised at what I find!`
        }
      }
    };
  }
};
</script>
<template>
  <div id="pd-left-container">
    <div id="special-offer">
      <h2>
        Deluxe Plan <span style="color: #fd0000; margin-left: 1rem">50%</span><span style="color: #fd0000; font-size: 0.85em"> off</span>
      </h2>
      <p><strike><strong>From over € 1,157</strong></strike><br /><span>For only € 499</span></p>
    </div>
    <div id="program-content">
      <h4>Dropsmart Deluxe includes:</h4>
      <ul>
        <li>
          1 Year of Subscription to Dropsmart <strike><strong>€ 197</strong></strike><br />
          <ul>
            <li>All premium features included.</li>
            <li>1 video lesson per month from Melani Kovač (our founder).</li>
            <li>Support online by email.</li>
          </ul>
        </li>
        <li>
          4 Full Live Lectures with Melani <strike><strong>€ 960</strong></strike>
          <ul>
            <li>A skill every aromatherapist should have and why.</li>
            <li>Why you should stop choosing your essential oils the old fashion way.</li>
            <li>How to 'reconstruct' rare and expensive essential oils with the ones you already have. Is it possible?</li>
            <li>Why science and tradition don't match, and does it really matter?</li>
          </ul>
          <br/>
          Lectures in 2021: June 26, October 16 at 7 pm CET<br/>
          Lectures in 2022: January 29, March 15 at 7 pm CET<br/>
          <i>Note: if the dates and times change, we will inform you.</i><br/>
        </li>
      </ul>
      <h4>Plus 12 Incredible BONUSES:</h4>
      <ul>
        <li>
          <!--strong>Bonus 1.</strong-->
          <div class="bonus">4 Downloadable PDFs (one for each lecture). <strike><strong>Priceless</strong></strike></div>
        </li>
        <li>
          <div class="bonus">4 Exclusive Q&amp;A sessions (one after each lecture). <strike><strong>Priceless</strong></strike></div>
        </li>
        <li>
          <div class="bonus">Access to the 4 recordings in your private area. <strike><strong>Priceless</strong></strike></div>
        </li>
      </ul>
      <h2 style="font-weight: 600; font-size: 1.5em; margin-top: 2em">You can cancel at any time. No hard feelings.</h2>
    </div>

    <div class="testimonials">
    <Testimonial :testimonial="testimonials.kristin" />
    <Testimonial :testimonial="testimonials.tammy" />
    <Testimonial :testimonial="testimonials.sylvia" />
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

* {
  font-family: $font-family;
}

#pd-left-container {
  font-size: 1.11rem;
  flex-basis: 100%;
}

#special-offer {
  h2 {
    font-size: 2em;
    text-transform: uppercase;
    font-weight: $font-bold;
  }
  p {
    font-size: 1.35em;
    text-align: center;
    padding: 1em;
    background-color: #ffea01;
  }
  span {
    font-size: 0.9em;
  }
}

.bonus {
   margin-left: 10px;
    display: inline;
}

#program-content {
  line-height: 1.77em;
  h4 {
    font-size: 1em;
    font-weight: 600;
    margin-bottom: 1em;
  }
  ul {
    margin-left: 1em;
    padding: 0;
  }
}
</style>